export default "__VITE_ASSET__DWqFChVZ__"